<template>
  <v-container fluid v-if="$apollo.loading">
    <v-row justify="center" align="center"
      ><v-progress-circular indeterminate color="primary"></v-progress-circular
    ></v-row>
  </v-container>
  <v-layout v-else>
    <v-flex xs12 class="text-xs-center tabs-container pt-0">
      <v-card
        :raised="!value"
        :flat="value != null"
        v-if="!$apollo.loading"
        class="pt-0"
      >
        <v-card-title v-if="!value">
          <h1 class="headline">{{ salesInvoice.number }}</h1>
        </v-card-title>
        <v-row>
          <basic-components-list
            :list="boxes"
            :data="salesInvoice"
            :visibleItems="boxesSettings.visibleItems"
            :columns="boxesSettings.columns"
            @change="onBoxesSettingsChange"
          ></basic-components-list>
        </v-row>
        <v-row v-if="debug">
          <v-col>
            <code>
              {{ gridHeight }}
            </code>
          </v-col>
        </v-row>
        <v-container fluid grid-list-xs pa-0 v-if="false">
          <v-layout row wrap fill-height>
            <v-flex xs12 sm4>
              <v-card color="box1-bg">
                <v-card-text class="white--text">
                  <p class="headline text-center pr-1">
                    <v-icon left dark large>mdi-account-tie</v-icon>Agent
                    <v-divider dark class="mt-1"></v-divider>
                  </p>
                  <p>
                    <strong class="overline">Name:</strong>
                    <v-spacer></v-spacer>
                    <span class="headline">{{ salesInvoice.agent.name }}</span>
                  </p>
                  <p>
                    <small class="overline">Address:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      salesInvoice.agent.address
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Telephone:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      salesInvoice.agent.telephone
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Email:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{ salesInvoice.agent.email }}</span>
                  </p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4>
              <v-card color="box2-bg">
                <v-card-text class="white--text">
                  <p class="headline text-center pr-1">
                    <v-icon left dark large>mdi-account</v-icon>Client
                    <v-divider dark class="mt-1"></v-divider>
                  </p>
                  <p>
                    <small class="overline">Name:</small>
                    <v-spacer></v-spacer>
                    <span class="headline"
                      >{{ salesInvoice.client.title }}
                      {{ salesInvoice.client.name }}
                      {{ salesInvoice.client.surname }}</span
                    >
                  </p>
                  <p>
                    <small class="overline">Telephone:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      salesInvoice.client.telephone
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Email:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      salesInvoice.client.email
                    }}</span>
                  </p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4>
              <v-card color="box3-bg">
                <v-card-text class="white--text">
                  <p class="headline text-center pr-1">
                    <v-icon left dark large>mdi-currency-usd</v-icon>Details
                    <v-divider dark class="mt-1"></v-divider>
                  </p>
                  <p>
                    <small class="overline">Invoice No:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{ salesInvoice.number }}</span>
                  </p>
                  <p>
                    <small class="overline">Itinerary Ref:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      salesInvoice.itineraryReference
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Invoice Date:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{ salesInvoice.createdAt }}</span>
                  </p>
                  <p class="headline">
                    <small class="overline">Invoice Amount:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">
                      {{ salesInvoice.amount | priceLabeler }}
                      {{ salesInvoice.currencyCode }}
                    </span>
                  </p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-col>
              <v-text-field
                v-model="externalReference"
                label="External Reference"
                :outlined="outlinedInputs"
                hide-details
              ></v-text-field>
            </v-col>
            <v-col>
              <v-row align="center" justify="center">
                <v-col>
                  <v-checkbox
                    v-model="approved"
                    @change="showApproveDialog = $event"
                    label="Full Invoice"
                    class="my-0"
                    hide-details
                  ></v-checkbox> </v-col
                ><v-col class="py-0">
                  <v-checkbox
                    v-model="exported"
                    label="Exported"
                    class="my-0"
                    :disabled="!$store.getters.hasAccessTo('finances:unexport')"
                    hide-details
                  ></v-checkbox
                ></v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row align="center" justify="end" class="mr-2">
                <v-switch
                  label="Show Included Only"
                  v-model="showIncludedOnly"
                />
              </v-row>
            </v-col>
          </v-row>
          <v-layout>
            <v-flex xs12>
              <v-card outlined>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :loading="$apollo.loading"
                  v-bind="pagingOptions"
                  item-key="id"
                  :height="gridHeight"
                  :fixed-header="fixedHeader"
                >
                  <template v-slot:item.startDate="{ item }">{{
                    item.startDate | formatDate
                  }}</template>
                  <template v-slot:item.endDate="{ item }">{{
                    item.endDate | formatDate
                  }}</template>
                  <template v-slot:item.totalPrice="{ item }"
                    >{{ item.totalPrice | priceLabeler }}
                    {{ salesInvoice.itinerary.currencyCode }}</template
                  >
                  <template v-slot:item.isIncluded="{ item }">
                    <v-simple-checkbox v-model="item.isIncluded" disabled />
                  </template>
                  <template v-slot:footer>
                    <v-layout justify-center>
                      <strong class="pr-3">
                        Total: {{ salesInvoice.amount | priceLabeler }}
                        {{ salesInvoice.itinerary.currencyCode }}
                      </strong>
                      <strong class="pr-3">
                        Paid: {{ salesInvoice.itinerary.paid | priceLabeler }}
                        {{ salesInvoice.itinerary.currencyCode }}
                      </strong>
                      <strong>
                        Balance:
                        {{
                          (Number(salesInvoice.amount) -
                            Number(salesInvoice.itinerary.paid))
                            | priceLabeler
                        }}
                        {{ salesInvoice.itinerary.currencyCode }}
                      </strong>
                    </v-layout>
                  </template>
                </v-data-table>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center v-if="!value">
            <v-btn color="primary" @click="saveSalesInvoice" class="mb-2"
              >Save</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
      <back-to-list-btn
        v-if="!value"
        route="/sales-invoices"
      ></back-to-list-btn>
    </v-flex>
    <confirmation-dialog
      :show-dialog="showApproveDialog"
      :max-width="650"
      @onCloseDialog="onCancelApprove"
      @onConfirm="saveSalesInvoice"
    >
      <template slot="message">
        If you approve this invoice you should restrict the changes that you
        make to this itinerary. Are you sure you want to generate a full
        invoice?
      </template>
    </confirmation-dialog>
  </v-layout>
</template>

<script>
import {
  SALES_INVOICE_RECORD_QUERY,
  SALES_INVOICE_UPDATE_MUTATION,
} from "../../../../constants/graphql";
import ConfirmationDialog from "../../shared/ConfirmationDialog";
import BackToListBtn from "../../shared/BackToListBtn";
import { sortByDate, pagingOptions } from "../../../../helpers/index";
import BasicComponentsList from "../../shared/BasicComponentsList";
import boxes from "./si-boxes-list.js";
export default {
  name: "SalesInvoiceDetails",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    ConfirmationDialog,
    BackToListBtn,
    BasicComponentsList,
  },

  data() {
    return {
      debug: false,
      pagingOptions,
      id: this.value ? this.value.id : this.$route.params.id,
      salesInvoice: {},
      approved: false,
      exported: false,
      showApproveDialog: false,
      externalReference: "",
      showIncludedOnly: true,
      headers: [
        { text: "Start Date", value: "startDate", sort: sortByDate },
        { text: "End Date", value: "endDate", sort: sortByDate },
        { text: "Service", value: "serviceName" },
        { text: "Supplier", value: "supplierName" },
        { text: "Qty", value: "qty" },
        { text: "Adults", value: "adults" },
        { text: "Children", value: "children" },
        { text: "Infants", value: "infants" },
        { text: "Rate", value: "rateTypeCode" },
        { text: "Included", value: "isIncluded" },
        { text: "Price", value: "totalPrice" },
      ],
      boxes: boxes,
      boxesSettings: this.$store.getters.localSettings(
        "salesInvoiceDetailsBoxesSettings",
        {
          visibleItems: ["Invoice No", "Amount", "Client"],
          coumns: 3,
        }
      ),
      fixedHeader: true,
      windowHeight: window.innerHeight,
    };
  },

  computed: {
    csvData() {
      if (!this.salesInvoice || !this.salesInvoice.itineraryItems) return [];
      const header = {
        "Invoice No": this.salesInvoice.number,
        Agent: this.salesInvoice.agent ? this.salesInvoice.agent.name : "",
        "Itin Ref": this.salesInvoice.itineraryReference
          ? this.salesInvoice.itineraryReference.split("/").pop()
          : "",
        Client: this.salesInvoice.client
          ? [this.salesInvoice.client.name, this.salesInvoice.client.surname]
              .filter(Boolean)
              .join(" ")
          : "",
        "Invoice Date": this.$options.filters.formatDate(
          this.salesInvoice.createdAt
        ),
        "External Ref": this.externalReference,
        "Full Invoice": this.approved ? "Yes" : "No",
        Exported: this.exported ? "Yes" : "No",
      };
      const rows = [];
      for (const { node } of this.salesInvoice.itineraryItems.edges) {
        rows.push({
          ...header,
          Supplier: node.supplierName,
          Service: node.serviceName,
          "Service Start Date": this.$options.filters.formatDate(node.startDate),
          "Service End Date": this.$options.filters.formatDate(node.endDate),
          QTY: node.qty,
          Adts: node.pax ? node.pax.adults : "",
          Chd: node.pax ? node.pax.children : "",
          Infs: node.pax ? node.pax.infants : "",
          "Rate Type Name (Code)": `${node.rateTypeName} (${node.rateTypeCode})`,
          Price: node.totalPrice,
          Included: node.isIncluded ? "Yes" : "No",
          Optional: "No",
        });
        if (node.extras && node.extras.length > 0) {
          for (const extra of node.extras) {
            rows.push({
              ...header,
              Supplier: node.supplierName,
              Service: extra.name,
              "Service Start Date": this.$options.filters.formatDate(
                extra.startDate
              ),
              "Service End Date": this.$options.filters.formatDate(
                extra.endDate
              ),
              QTY: extra.qty,
              Adts: extra.adults,
              Chd: extra.children,
              Infs: extra.infants,
              "Rate Type Name (Code)": `${extra.rateTypeName} (${extra.rateTypeCode})`,
              Price: extra.totalSell,
              Included: extra.isIncluded ? "Yes" : "No",
              Optional: extra.isOptional ? "Yes" : "No",
            });
          }
        }
      }
      return rows;
    },
    gridHeight() {
      if (!this.fixedHeader) {
        return null;
      }
      return this.items && this.items.length >= 10
        ? this.windowHeight - 430
        : null;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    items() {
      const list =
        this.salesInvoice && this.salesInvoice.itineraryItems
          ? this.salesInvoice.itineraryItems.edges.reduce((list, { node }) => {
              list.push({
                ...node,
                ...node.pax,
              });
              if (node.extras && node.extras.length > 0) {
                for (const extra of node.extras) {
                  list.push({
                    ...extra,
                    serviceName: extra.name,
                    supplierName: node.supplierName,
                    totalPrice: extra.totalSell,
                    isIncluded: extra.isIncluded,
                  });
                }
              }
              return list;
            }, [])
          : [];
      return this.showIncludedOnly
        ? list.filter((item) => item.isIncluded)
        : list;
    },
  },

  watch: {
    value(newVal) {
      this.id = newVal.id;
      this.showApproveDialog = false;
    },
    csvData(val) {
      this.$emit("csv-data-ready", val);
    },
  },

  methods: {
    saveSalesInvoice() {
      this.$apollo
        .mutate({
          mutation: SALES_INVOICE_UPDATE_MUTATION,
          variables: {
            id: this.id,
            approved: this.approved,
            externalReference: this.externalReference,
            exported: this.$store.getters.hasAccessTo("finances:unexport")
              ? this.exported
              : undefined,
          },
        })
        .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
    },
    saveGqlObjectHandler(result) {
      this.$store.dispatch("showAppSnackbar", {
        msg: "Sales Invoice Updated.",
      });
      this.$emit("updated", result.data.updateSalesInvoice);
    },
    saveGqlObjectErrorHandler(err) {
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
    },
    onCancelApprove() {
      this.showApproveDialog = false;
      this.approved = false;
    },
    backToList() {
      this.$router.go(-1);
    },
    onBoxesSettingsChange(payload) {
      this.$store.dispatch("updateLocalSettings", {
        salesInvoiceDetailsBoxesSettings: { ...payload },
      });
    },
  },

  apollo: {
    salesInvoice: {
      query: SALES_INVOICE_RECORD_QUERY,
      variables() {
        return {
          id: this.id,
        };
      },
      skip() {
        return !this.id;
      },
      result({ data, loader, networkStatus }) {
        this.approved = data.salesInvoice.approved;
        this.externalReference = data.salesInvoice.externalReference;
        this.exported = data.salesInvoice.exported;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped>
.box1-bg {
  background: linear-gradient(to right top, #37474f, #78909c);
  min-height: 380px;
}
.box2-bg {
  background: linear-gradient(to right top, #00695c, rgb(0, 196, 196));
  min-height: 380px;
}
.box3-bg {
  background: linear-gradient(to right top, #4a148c, #8e24aa);
  min-height: 380px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/finances/sales-invoices/SalesInvoiceDetails.vue